import React, { useState, useEffect } from "react";
import Logo from "../../images/new_logo.svg";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../components/Component";
import { Form, Spinner, Alert } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { handleGetApis, handlePostApis } from "../../service/Api";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [errorVal, setError] = useState("");
  const [auth, setAuth] = useState({
    username: "",
    password: "",
  });
  const navigate = useNavigate();

  // Redirect if already logged in by checking admin/me
  useEffect(() => {
    const checkLogged = async () => {
      try {
        const res = await handleGetApis(`admin/me`);
        if (res && res.status === 200) {
          navigate("/dashboard", { replace: true });
        }
      } catch (err) {
        // Not logged in, stay on login page
      }
    };
    checkLogged();
  }, [navigate]);

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    if (!auth.username || !auth.password) {
      setError("Both are required");
      setLoading(false);
      return;
    }
    const result = await handlePostApis('admin/login', auth);
    if(result.data.status){
      navigate('/dashboard')
    }
    else{
      setError(result.data.message);
      setLoading(false);
    }
  };
  return (
    <>
      <Head title="Login" />
      <Block className="nk-block-middle nk-auth-body  wide-xs">
        <div className="brand-logo pb-4 text-center">
          <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
            <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
            <img className="logo-dark logo-img logo-img-lg" src={Logo} alt="logo" />
          </Link>
        </div>

        <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
          <BlockHead>
            <BlockContent>
              <BlockTitle tag="h4">Sign-In</BlockTitle>
              <BlockDes>
                <p>Access RYZHM using your username and passcode.</p>
              </BlockDes>
            </BlockContent>
          </BlockHead>
          {errorVal && (
            <div className="mb-3">
              <Alert color="danger" className="alert-icon">
                <Icon name="alert-circle" /> {errorVal}{" "}
              </Alert>
            </div>
          )}
          <Form autoComplete="off" className="is-alter" onSubmit={handleAdminLogin}>
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label" htmlFor="default-01">
                  Username
                </label>
              </div>
              <div className="form-control-wrap">
                <input
                  type="text"
                  value={auth.username}
                  onChange={(e) => {
                    setAuth({ ...auth, username: e.target.value });
                  }}
                  placeholder="Enter your username"
                  className="form-control-lg form-control"
                />
              </div>
            </div>
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label" htmlFor="password">
                  Passcode
                </label>
              </div>
              <div className="form-control-wrap">
                <a
                  href="#password"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setPassState(!passState);
                  }}
                  className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                >
                  <Icon name="eye" className="passcode-icon icon-show"></Icon>

                  <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                </a>
                <input
                  type={passState ? "text" : "password"}
                  value={auth.password}
                  onChange={(e) => {
                    setAuth({ ...auth, password: e.target.value });
                  }}
                  placeholder="Enter your passcode"
                  className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                />
              </div>
            </div>
            <div className="form-group">
              <Button size="lg" className="btn-block" type="submit" color="primary">
                {loading ? <Spinner size="sm" color="light" /> : "Sign in"}
              </Button>
            </div>
          </Form>
        </PreviewCard>
      </Block>
    </>
  );
};
export default Login;
